<template>
  <div>
    <page-title :showBackButton="false" title="Default Home Page"></page-title>
    <v-alert type="info">
      Please change home page in Developer > UI > Appliaction settings.
    </v-alert>
  </div>
</template>

<script>
import { useUserStore } from "../store/user";
import PageTitle from "../components/shared/PageTitle.vue";

export default {
  name: "DefaultPage",

  components: { PageTitle },

  mounted() {
    const userStore = useUserStore();

    if (userStore.homePage !== "/default") {
      this.$router.replace(userStore.homePage);
    }
  },
};
</script>